(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-bike"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bike-rail')) {
    customElements.define('bike-rail', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        if (!this.rail) return;
        this.speed = (parseFloat(this.dataset.speed) || 0) * 0.08;   /* slider 0-10 -> px per frame */
        this.pos = this.rail.scrollLeft;
        this.paused = false;
        this.cards = this.rail.children.length;
        var self = this;

        var pause = function () {
          self.paused = true;
          clearTimeout(self.resume);
          self.resume = setTimeout(function () { self.paused = false; self.pos = self.rail.scrollLeft; }, 2200);
        };
        ['pointerdown', 'wheel', 'touchstart', 'focusin'].forEach(function (ev) {
          self.rail.addEventListener(ev, pause, { passive: true });
        });
        this.rail.addEventListener('mouseenter', function () { self.paused = true; });
        this.rail.addEventListener('mouseleave', function () { self.paused = false; self.pos = self.rail.scrollLeft; });

        this.querySelectorAll('[data-dir]').forEach(function (b) {
          b.addEventListener('click', function () {
            pause();
            self.rail.scrollBy({ left: 320 * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
          });
        });

        this.idx = this.querySelector('[data-idx]');
        this.prog = this.querySelector('[data-prog]');
        this.rail.addEventListener('scroll', function () { self.update(); }, { passive: true });
        this.update();

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.speed > 0 && !reduce && !(window.Shopify && window.Shopify.designMode)) {
          var tick = function () {
            if (!self.isConnected) return;
            if (!self.paused) {
              var max = self.rail.scrollWidth - self.rail.clientWidth;
              self.pos += self.speed;
              if (self.pos >= max) self.pos = 0;
              self.rail.scrollLeft = self.pos;
            }
            requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      }
      update() {
        var max = this.rail.scrollWidth - this.rail.clientWidth;
        var pct = max > 0 ? this.rail.scrollLeft / max : 0;
        if (this.prog) this.prog.style.width = Math.max(10, Math.round(pct * 100)) + '%';
        if (this.idx && this.cards) {
          var n = Math.min(this.cards, Math.round(pct * (this.cards - 1)) + 1);
          this.idx.textContent = ('0' + n).slice(-2);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
